import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import EmojiEvents from "@mui/icons-material/EmojiEvents";
import PictureAsPdf from "@mui/icons-material/PictureAsPdf";
import TrendingUp from "@mui/icons-material/TrendingUp";
import { alpha } from "@mui/material/styles";
import { customTheme } from "./ExamModesMarketing"; // Adjust the path as necessary

const StatisticsSection = () => (
  <Box
    sx={{
      maxWidth: { xs: 300, md: 1200 },
      mx: "auto",
      px: 4,
      my: 14,
      py: 6,
      bgcolor: alpha(customTheme.palette.primary.main, 0.05),
      borderRadius: 4,
      border: "3px solid #27b1bb",
    }}
  >
    <Typography
      variant="h4"
      component="h2"
      gutterBottom
      align="center"
      fontWeight="bold"
      mb={6}
    >
      Our Milestones
    </Typography>
    <Grid container spacing={4} justifyContent="center">
      {[
        {
          icon: <EmojiEvents fontSize="large" />,
          value: "100%",
          label: "Pass Rate",
        },
        {
          icon: <PictureAsPdf fontSize="large" />,
          value: "2,500+",
          label: "Courses",
        },
        {
          icon: <TrendingUp fontSize="large" />,
          value: "1000+",
          label: "Certified Professionals",
        },
      ].map((stat, index) => (
        <Grid item xs={12} sm={4} key={index}>
          <Box sx={{ textAlign: "center" }}>
            <Box sx={{ color: "#27b1bb", mb: 2 }}>{stat.icon}</Box>
            <Typography
              variant="h3"
              component="p"
              fontWeight="bold"
              sx={{ color: "#27b1bb" }}
            >
              {stat.value}
            </Typography>
            <Typography variant="h6" component="span" color="text.secondary">
              {stat.label}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default StatisticsSection;
